import React, { useEffect, useRef, useState } from "react";
import {
  AlertDialog,
  AlertDialogContent,
  AlertDialogHeader,
  AlertDialogFooter,
  AlertDialogTitle,
  AlertDialogDescription,
  AlertDialogAction,
  AlertDialogCancel,
} from "@/components/ui/alert-dialog";

// Imperative confirm dialog — pengganti window.confirm yang andal di dalam iframe preview
// (browser sering memblokir window.confirm pada cross-origin iframe sehingga selalu return false).
let _handler = null;

export function confirmDialog(opts) {
  const o = typeof opts === "string" ? { description: opts } : (opts || {});
  if (!_handler) {
    // fallback bila root belum ter-mount
    return Promise.resolve(window.confirm(o.description || o.title || "Yakin?"));
  }
  return _handler(o);
}

export function ConfirmRoot() {
  const [state, setState] = useState({ open: false });
  const resolverRef = useRef(null);

  useEffect(() => {
    _handler = (o) => new Promise((resolve) => {
      resolverRef.current = resolve;
      setState({ open: true, ...o });
    });
    return () => { _handler = null; };
  }, []);

  const finish = (val) => {
    setState((s) => ({ ...s, open: false }));
    const r = resolverRef.current;
    resolverRef.current = null;
    if (r) r(val);
  };

  return (
    <AlertDialog open={!!state.open} onOpenChange={(op) => { if (!op) finish(false); }}>
      <AlertDialogContent data-testid="confirm-dialog">
        <AlertDialogHeader>
          <AlertDialogTitle>{state.title || "Konfirmasi"}</AlertDialogTitle>
          {state.description ? <AlertDialogDescription>{state.description}</AlertDialogDescription> : null}
        </AlertDialogHeader>
        <AlertDialogFooter>
          <AlertDialogCancel data-testid="confirm-cancel" onClick={() => finish(false)}>{state.cancelText || "Batal"}</AlertDialogCancel>
          <AlertDialogAction
            data-testid="confirm-ok"
            className={state.destructive === false ? "" : "bg-rose-600 hover:bg-rose-700 focus:ring-rose-600 text-white"}
            onClick={() => finish(true)}
          >
            {state.confirmText || "Hapus"}
          </AlertDialogAction>
        </AlertDialogFooter>
      </AlertDialogContent>
    </AlertDialog>
  );
}
